"use client"

import { type ButtonHTMLAttributes, forwardRef } from "react"
import { cn } from "./cn"

export type ConsentButtonVariant = "primary" | "outline" | "ghost"

const VARIANT_CLASSES: Record<ConsentButtonVariant, string> = {
  primary: "bg-foreground text-background hover:bg-foreground/90 border border-transparent",
  outline:
    "border border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground",
  ghost:
    "bg-transparent text-muted-foreground hover:bg-accent hover:text-accent-foreground border border-transparent",
}

const BASE_CLASSES = [
  "inline-flex items-center justify-center",
  "h-9 px-4 py-2 rounded-md",
  "text-sm font-medium leading-none",
  "transition-colors whitespace-nowrap cursor-pointer",
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
  "disabled:pointer-events-none disabled:opacity-50",
].join(" ")

export interface ConsentButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ConsentButtonVariant
}

export const Button = forwardRef<HTMLButtonElement, ConsentButtonProps>(
  ({ className, variant = "primary", type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(BASE_CLASSES, VARIANT_CLASSES[variant], className)}
      {...props}
    />
  ),
)
Button.displayName = "Button"
